module.exports = __webpack_public_path__ + "img/trunk_11x1_z18.b3b176e8.svg";